import React, { useState, useCallback } from "react";
import "./With.css";
import axios from "axios";
import { useEffect } from "react";
import ContractDetails from "../../Contracts/ContractDetails";
import { Container, Row, Col } from "react-bootstrap";
import { ethers } from "ethers";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toastFailed, toastSuccess } from "../../Common/Data";
import {
  approveWithdrawalRequest,
  fetchAllTransaction,
  rejectWithdrawalRequest,
} from "../../Actions/adminActions";
import { useDispatch } from "react-redux";
import Tether from "../../Images/tether-usdt-logo.png";
import apiCall from "../../API/API";
import GetChainId from "../../Common/GetChainId";
import {
  useWalletClient,
  useAccount,
  useWaitForTransactionReceipt,
  useSendTransaction,
  useWriteContract,
  usePublicClient,
} from "wagmi";
import { parseUnits, encodeFunctionData } from "viem";
import GetUSDTBalance from "../../Common/GetUsdtBalance";
import ensureAllowance from "../../Common/ensureAllowance";
import Loader from "../../Component/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";

const WithdrawnDetails = () => {
  const { BigInt } = window;
  const location = useLocation();
  // const account = useSelector((state) => state.accounts.value);
  const [usdt, setUsdt] = useState(false);
  const [atm, setAtm] = useState(false);
  const [show, setShow] = useState(false);
  const {
    amountArray = [],
    walletAddressArray = [],
    usernameArray = [],
    tx_IdsArray = [],
  } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedToken, setSelectedToken] = useState();
  const [companyDetails, setCompanyDetails] = useState();

  const { data: walletClient } = useWalletClient();
  const { address: account } = useAccount();
  const { writeContractAsync } = useWriteContract();
  const publicClient = usePublicClient();
  const [loading, setLoading] = useState(false);
  async function handleWithdraw() {
    try {
      if (!walletClient || !account) {
        toast.error("Please connect your wallet.");
        return;
      }

      if (
        !Array.isArray(amountArray) ||
        !Array.isArray(walletAddressArray) ||
        !Array.isArray(tx_IdsArray) ||
        amountArray.length === 0 ||
        amountArray.length !== walletAddressArray.length ||
        amountArray.length !== tx_IdsArray.length
      ) {
        toast.error(
          "Invalid withdrawal request data. Arrays must have the same length."
        );
        return;
      }

      setLoading(true);

      // Parse each amount to token decimals (adjust if token is 6 decimals)

      const parsedAmounts = amountArray?.map((amt) => {
        const parsed = parseUnits(amt.toString(), 18); // returns bigint
        console.log("amount", amt);
        console.log("parsedAmount", parsed.toString()); // ✅ safe
        return parsed;
      });

      console.log(
        "Parsed Amounts:",
        parsedAmounts.map((a) => a.toString()) // ✅ all safe
      );

      const parsedTxIds = tx_IdsArray.map((txid) => BigInt(txid));

      // Calculate total amount for allowance
      const totalAmount = parsedAmounts.reduce((acc, a) => acc + a, 0n);
      console.log("Total Amount:", totalAmount.toString());

      // 1) Ensure safe allowance for contract
      const allowanceOk = await ensureAllowance({
        account,
        publicClient,
        walletClient,
        token: ContractDetails.BUSD,
        spender: ContractDetails.contract,
        amount: totalAmount,
      });

      if (!allowanceOk) {
        toast.error("Allowance failed.");
        return;
      }

      // 2) Simulate sendTokensToMultipleAddresses
      const { request } = await publicClient.simulateContract({
        abi: ContractDetails.contractABI,
        address: ContractDetails.contract,
        functionName: "sendUSDTToMultipleAddresses",
        args: [parsedAmounts, walletAddressArray, parsedTxIds],
        account,
        value: 0n,
      });

      // 3) Execute transaction
      const txHash = await walletClient.writeContract(request);

      console.log("txHash", txHash);

      const receipt = await publicClient.waitForTransactionReceipt({
        hash: txHash,
      });

      if (receipt.status !== "success") {
        toast.error("Withdrawal transaction failed.");
        return;
      }

      // 4) Update backend
      await dispatch(approveWithdrawalRequest(tx_IdsArray, txHash));
      navigate("/dashboard");
      toast.success("Withdrawal successful ✅");
    } catch (error) {
      console.error("Withdrawal failed:", error);
      const message =
        error?.shortMessage || error?.message || "Transaction failed.";

      if (error?.code === "TIMEOUT") {
        toast.error("Transaction timeout. Check your wallet.");
      } else if (
        message.toLowerCase().includes("simulation") ||
        message.toLowerCase().includes("gas")
      ) {
        toast.error("Gas/simulation failed. Check token decimals & args.");
      } else if (error?.code === 4001 || error?.code === "ACTION_REJECTED") {
        toast.error("Transaction rejected by user.");
      } else {
        toast.error(message);
      }
    } finally {
      setLoading(false);
    }
  }
  const handleToken = (token) => {
    console.log("token details", token);
    setSelectedToken(token);
    setShow(false);
  };

  useEffect(() => {
    if (selectedToken) {
      console.log("token is selected!");
      console.log("amountArray", amountArray);
      console.log("walletAddressArray", walletAddressArray);
      handleWithdraw();
    }
  }, [selectedToken]);

  const handleNotWithDap = () => {
    navigate("/dashboard/withdraw_controls");
  };

  const getCompanyDetails = async () => {
    try {
      const res = await apiCall("GET", "/get-company-info");
      console.log("company details", res);
      setCompanyDetails(res?.data?.company_info);
    } catch (error) {
      console.error(error.message);
    }
  };

  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getCompanyDetails();
      x++;
    }
  }, []);

  return (
    <React.Fragment>
      {loading ? <Loader /> : null}
      <Container>
        {show && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Select Token For Withdrawal</h2>
              <div className="tokenSelection">
                {companyDetails?.tokens
                  ?.filter((token) => token.enabled === 1)
                  ?.map((token, i) => (
                    <div
                      key={i}
                      className="tokenDiv"
                      onClick={() => handleToken(token)}
                    >
                      <span>{token?.tokenName}</span>
                      {token?.token_image?.startsWith("<svg") ? (
                        <span
                          style={{ marginLeft: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: token?.token_image,
                          }}
                        />
                      ) : (
                        <img
                          src={token?.token_image}
                          alt={token?.tokenSymbol}
                          style={{ marginLeft: "5px", height: "40px" }}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        <div id="directIncomeDiv">
          <div className="button-container">
            <button
              className="action-btn"
              // onClick={() => setShow(true)}
              onClick={handleWithdraw}
            >
              Proceed
            </button>
            <button className="action-btn" onClick={handleNotWithDap}>
              Cancel
            </button>
          </div>

          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%", display: "flex" }}>
                <table>
                  <tr>
                    <th>S. No.</th>
                    <th>Username</th>
                    <th>Wallet Address</th>
                    <th>Amount</th>
                  </tr>
                  <tbody>
                    {amountArray.map((amount, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{usernameArray[i]}</td>
                        <td>{walletAddressArray[i]}</td>
                        <td>{amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Container>
    </React.Fragment>
  );
};

export default WithdrawnDetails;
